<template>
  <div class="marketPage main-bg">
    <!-- 24小时行情 -->
    <div class="market-block">
      <MarketRecommand v-if="!fromHome"></MarketRecommand>
      <market
        :exchangeDataList="fromHome ? homeTableDataList : tableDataList"
        :futureDataList="fromHome ? homeFutureDataList : futureDataList"
        :fromHome="fromHome"
      ></market>
      <!-- <p v-if="fromHome" class="view-more blue-cl" @click="$router.push('/market')">
        {{ $t("header.more") }}
        <svg-icon iconClass="arrow-right" className="icon-14 ml-8"></svg-icon>
      </p> -->
    </div>
    <i v-if="!baseInfo"></i>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import exchangeWorker from '@/utils/webWorker';
import futureWorker from '@/utils/futureWorker';
import { myStorage, getSpotWsUrl, getFutureWsUrl } from '@/utils';
import MarketRecommand from './market/MarketRecommand.vue';
import market from './market/market.vue';

export default {
  props: {
    fromHome: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MarketRecommand,
    market,
  },
  data() {
    return {
      // 市场数据
      marketData: null,
      // 当前市场
      marketCurrent: null,
      // 当前币对
      symbolCurrent: null,
      // 24小时行情WS数据
      exchangeMarketDataObj: [],
      tableDataList: [],
      // 推荐位数据
      recommendDataList: {},
      klineDataList: {},
      futureKlineDataList: {},
      // 自选币对
      mySymbolList: [],
      setMyMarketSwitch: true,
      // 行情传递列表数据
      dataList: {},
      klineDataListOpt: {},
      quotationsShow: false,
      coHeaderSymbol: [],
      futureDataList: [],
      futureContractList: [],
      futureMarketDataObj: [],
    };
  },
  computed: {
    ...mapState({
      baseInfo({ baseData }) {
        this.marketData = baseData.market;
        // 获取当前市场
        this.marketCurrent = myStorage.get('homeMarkTitle');
        // 获取当前币对
        this.symbolCurrent = myStorage.get('sSymbolName');
        return baseData;
      },
      /**
       * 合约数据
       */
      future({ future }) {
        this.futureContractList = future.contractList || [];
        return future;
      },
    }),

    // WS exchangeWorker
    exchangeWorker() {
      return exchangeWorker();
    },

    // 合约worker
    futureWorker() {
      return futureWorker();
    },

    // 全部 货币对
    symbolAll() {
      return this.$store.state.baseData.symbolAll;
    },

    // 当前市场列表
    currentMarketList() {
      return this.marketData ? this.marketData.market : null;
    },

    // 推荐位 币对
    headerSymbol() {
      if (this.marketData) {
        return this.marketData.headerSymbol;
      }
      return [];
    },

    // 当前币对列表
    symbolList() {
      // 如果 当前市场 是 自选市场
      if (this.marketCurrent === 'myMarket') {
        const mySymbol = myStorage.get('mySymbol') || [];
        const marketList = {};
        if (mySymbol.length) {
          mySymbol.forEach((item) => {
            if (item && this.symbolAll[item]) {
              marketList[item] = this.symbolAll[item];
            }
          });
        }
        return marketList;
      }
      if (this.currentMarketList && this.marketCurrent) {
        return this.currentMarketList[this.marketCurrent];
      }
      return null;
    },

    // 汇率单位
    rateData() {
      return this.$store.state.baseData.rate;
    },

    isLogin() {
      return this.$store.state.baseData.isLogin;
    },

    // 首页现货数据 首页展示4个
    homeTableDataList() {
      return this.tableDataList.slice(0, 4);
    },

    // 首页合约数据 首页展示4个
    homeFutureDataList() {
      return this.futureDataList.slice(0, 4);
    },
  },
  watch: {
    /**
     * 合约ws连接
     */
    future() {
      this.futureWorker.postMessage({
        type: 'CREAT_WEBSOCKET',
        data: {
          wsUrl: getFutureWsUrl(),
          lan: this.$store.state.baseData.lan,
          rate: '',
          symbolAll: {},
        },
      });
    },

    symbolList(val, oldVal) {
      if (oldVal) {
        this.exchangeWebSocketSend('Market', 'unsub', this.symbolCurrent, oldVal);
        this.exchangeWebSocketSend('Market', 'sub', this.symbolCurrent, val);
      }
    },

    // 监听 是否登录
    isLogin() {
      this.getMySymbol();
    },

    // 监听获取到 market 接口的数据
    marketData() {
      // 创建WS
      this.exchangeWorker.postMessage({
        type: 'CREAT_WEBSOCKET',
        data: {
          wsUrl: getSpotWsUrl(),
          lan: this.$store.state.baseData.lan,
          rate: this.rateData,
          symbolAll: this.symbolAll,
        },
      });
    },
  },
  beforeDestroy() {
    const wsDataKey = this.futureContractList.map(item => item.wsDatakey);
    this.exchangeWebSocketSend('Market', 'unsub', this.symbolCurrent, this.symbolList);
    this.futureWebSocketSend('Market', 'unsub', wsDataKey);
    this.$bus.$off('SWITCH-STORE');
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.initFutureLogic();
      this.onExchangeMessageWorker();
      this.$bus.$on('SWITCH-STORE', (data) => {
        this.setMyMarket(data);
      });
      this.getMySymbol();
    },

    initFutureLogic() {
      this.$store.dispatch('getFutorePublicInfo');
      this.onFutureMessageWorker();
    },

    /**
     * 现货worker数据
     */
    onExchangeMessageWorker() {
      this.exchangeWorker.onmessage = (event) => {
        const { data } = event;
        // 监听 WebSocket 链接成功
        if (data.type === 'WEBSOCKET_ON_OPEN') {
          this.initExchangeSocket();
        }
        // 监听 WS 数据
        if (data.type === 'WEBSOCKET_DATA') {
          this.listenExchangeWsData(data.data);
        }
      };
    },

    /**
     * 合约worker数据
     */
    onFutureMessageWorker() {
      this.futureWorker.onmessage = (event) => {
        const { data } = event;
        // socket连接成功
        if (data.type === 'WEBSOCKET_ON_OPEN') {
          this.initFuturesSocket();
        }
        if (data.type === 'WEBSOCKET_DATA') {
          this.listenFutureWsData(data.data);
        }
      };
    },

    /**
     * 初始化现货socket
     */
    initExchangeSocket() {
      if (!this.symbolList) {
        return;
      }
      const symbolListKey = Object.keys(this.symbolList);
      const objData = {};
      symbolListKey.forEach((item) => {
        objData[item] = this.symbolList[item];
      });
      this.headerSymbol.forEach((item) => {
        if (symbolListKey.indexOf(item) < 0 && this.symbolAll[item]) {
          objData[item] = this.symbolAll[item];
        }
      });
      // 发送 24小时行情历史数据 Send
      this.exchangeWebSocketSend('Review');
      // 发送 24小时行情实时数据 Send
      this.exchangeWebSocketSend('Market', 'sub', this.symbolCurrent, objData);
      // 发送 所有币对的 kline数据 Send
      if (Array.isArray(symbolListKey) && symbolListKey.length > 0) {
        symbolListKey.forEach((item) => {
          const symbolArr = item.toLowerCase().split('/');
          const symbol = symbolArr[0] + symbolArr[1];
          this.exchangeWorker.postMessage({
            type: 'WEBSOCKET_KLINE_SEND',
            data: {
              symbol,
              type: 'req',
              lastTimeS: '1min',
              lTime: false,
              number: 30,
              symbolCurrent: item,
            },
          });
          this.exchangeWorker.postMessage({
            type: 'WEBSOCKET_KLINE_SEND',
            data: {
              symbol,
              type: 'sub',
              lastTimeS: '1min',
              lTime: false,
              symbolCurrent: item,
            },
          });
        });
      }
    },

    /**
     * 初始化合约socket
     */
    initFuturesSocket() {
      const wsDataKey = this.futureContractList.map(item => item.wsDatakey);
      this.futureWebSocketSend('Review');
      this.futureWebSocketSend('Market', 'sub', wsDataKey);
      // 发送 所有币对的 kline数据 Send
      if (Array.isArray(wsDataKey) && wsDataKey.length > 0) {
        wsDataKey.forEach((item) => {
          const symbol = item;
          this.futureWorker.postMessage({
            type: 'WEBSOCKET_KLINE_SEND',
            data: {
              symbol,
              type: 'req',
              lastTimeS: '1min',
              lTime: false,
              number: 30,
            },
          });
          this.futureWorker.postMessage({
            type: 'WEBSOCKET_KLINE_SEND',
            data: {
              symbol,
              type: 'sub',
              lastTimeS: '1min',
              lTime: false,
            },
          });
        });
      }
    },

    /**
     * 监听现货 ws 返回的数据
     * @param {*} data
     */
    listenExchangeWsData(data) {
      const { type, WsData } = data;
      // 24小时行情数据
      if (type === 'MARKET_DATA') {
        this.exchangeMarketDataObj = WsData;
        this.setExchangeMarketData();
        this.setExchangeRecommendData();
      }
      if (type.indexOf('KLINE_DATA') > -1) {
        const symbolListKey = Object.keys(this.symbolList);
        if (symbolListKey.length) {
          symbolListKey.forEach((key) => {
            const [, symbolType] = WsData.channel.split('_');
            const symbolArr = key.toLowerCase().split('/');
            const symbol = symbolArr[0] + symbolArr[1];
            if (symbol === symbolType) {
              if (WsData.event_rep === 'rep') {
                const kData = WsData.data;
                this.klineDataList[key] = [];
                const lengthNumber = kData.slice(-20);
                lengthNumber.forEach((item) => {
                  this.klineDataList[key].push([item.id, item.close]);
                });
              } else {
                const kData = WsData.tick;
                const keyYs = this.klineDataList[key] || [];
                const lengths = keyYs.length;
                if (
                  this.klineDataList
                  && this.klineDataList[key]
                  && this.klineDataList[key].length
                ) {
                  const lastId = this.klineDataList[key][lengths - 1][0];
                  if (lastId === kData.id) {
                    this.klineDataList[key].pop();
                  }
                  if (this.klineDataList[key].length > 20) {
                    this.klineDataList[key].shift();
                  }
                  this.klineDataList[key].push([kData.id, kData.close]);
                }
              }
            }
          });
          this.$bus.$emit('EXCHANGE_MARKET_KLINE_DATA', this.klineDataList);
        }
      }
    },

    /**
     * 监听合约ws返回的数据
     */
    listenFutureWsData(data) {
      const { type, WsData } = data;
      if (type === 'FUTURE_MARKET_DATA') {
        this.futureMarketDataObj = JSON.parse(WsData);
        this.setFutureMarketData();
        this.setFutureRecommendData();
      }
      if (type.indexOf('KLINE_DATA') > -1) {
        const contractNames = this.futureContractList.map(item => this.getContractName(item));
        if (Array.isArray(contractNames) && contractNames.length > 0) {
          const parsedWsData = JSON.parse(WsData);
          contractNames.forEach((key) => {
            const channel = parsedWsData.channel;
            if (channel.indexOf('_1min') === -1) {
              return false;
            }
            if (channel.indexOf(key.toLowerCase()) > -1) {
              if (parsedWsData.event_rep === 'rep') {
                const kData = parsedWsData.data;
                this.futureKlineDataList[key] = [];
                const lengthNumber = kData.slice(-20);
                lengthNumber.forEach((item) => {
                  this.futureKlineDataList[key].push([item.id, item.close]);
                });
              } else {
                const kData = parsedWsData.tick;
                const keyYs = this.futureKlineDataList[key] || [];
                const lengths = keyYs.length;
                if (
                  this.futureKlineDataList
                  && this.futureKlineDataList[key]
                  && this.futureKlineDataList[key].length
                ) {
                  const lastId = this.futureKlineDataList[key][lengths - 1][0];
                  if (lastId === kData.id) {
                    this.futureKlineDataList[key].pop();
                  }
                  if (this.futureKlineDataList[key].length > 20) {
                    this.futureKlineDataList[key].shift();
                  }
                  this.futureKlineDataList[key].push([kData.id, kData.close]);
                }
              }
            }
          });
          this.$bus.$emit('FUTURE_MARKET_KLINE_DATA', this.futureKlineDataList);
        }
      }
    },

    /**
     * 币币行情发送socket
     * @param {*} type
     * @param {*} sendType
     * @param {*} symbolData
     * @param {*} symbolList
     */
    exchangeWebSocketSend(type, sendType, symbolData, symbolList) {
      this.exchangeWorker.postMessage({
        type: 'WEBSOCKET_SEND',
        data: {
          type,
          sendType,
          symbolData,
          symbolList,
        },
      });
    },

    /**
     * 合约行情发送socket
     * @param {*} type
     * @param {*} sendType
     * @param {*} symbolData
     * @param {*} symbolList
     */
    futureWebSocketSend(type, sendType, symbolList) {
      this.futureWorker.postMessage({
        type: 'WEBSOCKET_SEND',
        data: {
          type,
          sendType,
          symbolList,
        },
      });
    },

    /**
     * 格式化 现货推荐位的24小时行情数据
     * 格式化 推荐位的 K线数据
     */
    setExchangeRecommendData() {
      if (this.headerSymbol.length) {
        this.headerSymbol.forEach((item) => {
          if (this.exchangeMarketDataObj && this.exchangeMarketDataObj[item]) {
            this.recommendDataList[item] = this.exchangeMarketDataObj[item];
          }
        });
        this.$bus.$emit('RECOMMEEND_DATA', this.recommendDataList);
      }
    },

    setFutureRecommendData() {
      if (this.headerSymbol.length) {
        this.headerSymbol.forEach((item) => {
          const key = `e_${item.toLowerCase()}`;
          if (this.futureMarketDataObj && this.futureMarketDataObj[key]) {
            this.recommendDataList[item] = this.futureMarketDataObj[key];
          }
        });
        this.$bus.$emit('RECOMMEEND_DATA', this.recommendDataList);
      }
    },

    /**
     * 格式化 现货列表数据
     */
    setExchangeMarketData() {
      const tableDataList = [];
      if (!this.symbolList) return;
      const keyarr = Object.keys(this.symbolList);
      keyarr.forEach((item) => {
        const itemData = this.exchangeMarketDataObj[item];
        if (itemData) {
          tableDataList.push(itemData);
          this.tableDataList = tableDataList;
        }
      });
    },

    /**
     * 格式化 合约列表数据
     */
    setFutureMarketData() {
      const futureDataList = [];
      this.futureContractList.forEach((item) => {
        const itemData = this.futureMarketDataObj[item.wsDatakey];
        if (itemData) {
          this.$set(itemData, 'name', this.getContractName(item));
          this.$set(itemData, 'wsDatakey', item.wsDatakey);
          this.$set(itemData, 'contractName', item.contractName);
          this.$set(itemData, 'contractType', 'E');
          futureDataList.push(itemData);
          this.futureDataList = futureDataList;
        }
      });
    },

    /**
     * 获取合约名称
     */
    getContractName(contractInfo) {
      let name = '';
      let text = '';
      if (contractInfo) {
        const nameText = contractInfo.symbol ? contractInfo.symbol.replace('-', '') : '';
        if (contractInfo.contractType !== 'E') {
          text = `-${contractInfo.marginCoin}`;
        }
        name = `${nameText}${text}`;
      }
      return name;
    },

    /**
     * 设置币对是否收藏的ICON
     */
    myMarketIcon(symbol) {
      return this.mySymbolList.includes(symbol);
    },

    /**
     * 设置 自选币对
     */
    setMyMarket(symbol) {
      const addUrl = this.$store.state.url.common.market_collect_add_symbol;
      const deleteUrl = this.$store.state.url.common.market_collect_remove_symbol;
      // 防止重复点击
      if (!this.setMyMarketSwitch) {
        return;
      }

      this.setMyMarketSwitch = false;

      let mySymbol = myStorage.get('mySymbol') || [];
      let isAdd = true;
      if (mySymbol.length && mySymbol.indexOf(symbol) > -1) {
        mySymbol = mySymbol.filter(item => item !== symbol);
        isAdd = false;
      } else {
        mySymbol.push(symbol);
        isAdd = true;
      }
      let url = addUrl;
      if (this.isLogin) {
        if (!isAdd) {
          url = deleteUrl;
        }
        this.axios({
          url,
          params: {
            type: symbol.indexOf('/') > -1 ? '0' : '1', // 0 现货 1 合约
            code: symbol,
          },
          method: 'post',
        }).then((data) => {
          if (data.code === '0') {
            this.setMyMarketSwitch = true;
            this.mySymbolList = mySymbol;
            myStorage.set('mySymbol', mySymbol);
            this.setExchangeMarketData();
            this.setFutureMarketData();
          } else {
            this.$bus.$emit('tip', { text: data.msg, type: 'error' });
          }
        });
      } else {
        this.setMyMarketSwitch = true;
        this.mySymbolList = mySymbol;
        myStorage.set('mySymbol', mySymbol);
      }
    },

    // 如果用户已登录,那么自选币对从服务端获取,并替换当前自选币对,获取服务端自选币对
    getMySymbol() {
      if (!this.isLogin) {
        this.mySymbolList = myStorage.get('mySymbol') || [];
        return;
      }
      myStorage.set('mySymbol', []);
      const url = this.$store.state.url.common.market_collect_get_symbol;
      this.axios({
        url: url,
        params: {
          type: null,
        },
        method: 'post',
      }).then((data) => {
        if (data.code === '0') {
          let webMySymbol = [];
          if (Array.isArray(data.data) && data.data.length > 0) {
            webMySymbol = data.data.map(item => item.code);
          }
          myStorage.set('mySymbol', webMySymbol);
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.marketPage {
  position: relative;
  padding: 5px;
  // min-height: 800px;
  min-width: 1200px;
  .market-block {
    width: 1200px;
    margin: 0 auto;

    .view-more {
      margin: 12px auto;
      padding: 12px;
      text-align: center;
      cursor: pointer;
      width: 200px;
    }
  }
}
</style>
